import {
  Component,
  Suspense,
  type ErrorInfo,
  type PropsWithChildren,
} from "react";
import { LoaderWithMessages } from "rujira.ui";

/** Last-resort loading boundary for providers above the page and modal outlets.
 * Keep their committed session state alive while an asynchronous read settles.
 * The narrower page/background boundaries still handle normal loading.
 */
export class ApplicationBoundary extends Component<
  PropsWithChildren,
  { error: Error | null }
> {
  state = { error: null as Error | null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // Local developer diagnostics only: no wallet state or remote telemetry.
    console.error("Application render failed", error, info.componentStack);
  }

  render() {
    if (!this.state.error)
      return (
        <Suspense fallback={<LoaderWithMessages />}>
          {this.props.children}
        </Suspense>
      );

    return (
      <main
        style={{
          minHeight: "100vh",
          padding: "3rem",
          background: "#11121b",
          color: "#fff",
          fontFamily: "sans-serif",
        }}>
        <h1>Unable to start Rujira</h1>
        <p>{this.state.error.message || String(this.state.error)}</p>
        <button type="button" onClick={() => window.location.reload()}>
          Reload
        </button>
      </main>
    );
  }
}
